var loadScript = function loadScript(src, options) {
  if (options === void 0) {
    options = {};
  }
  return new Promise(function (resolve) {
    var script = document.createElement('script');
    script.src = src;
    script.addEventListener('load', function () {
      resolve(script);
    });
    for (var _i = 0, _a = Object.entries(options); _i < _a.length; _i++) {
      var _b = _a[_i],
        key = _b[0],
        value = _b[1];
      script.setAttribute(key, value);
    }
    document.head.append(script);
  });
};

export { loadScript as default, loadScript };
//# sourceMappingURL=index.js.map
